import { render, staticRenderFns } from "./QIcon.vue?vue&type=template&id=af69328c&scoped=true"
import script from "./QIcon.vue?vue&type=script&lang=js"
export * from "./QIcon.vue?vue&type=script&lang=js"
import style0 from "./QIcon.vue?vue&type=style&index=0&id=af69328c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af69328c",
  null
  
)

/* custom blocks */
import block0 from "./QIcon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports